<ng-container *ngIf="data$ | async as data">
  <cx-generic-link
    *ngIf="data$ | async as data"
    [url]="data.link"
    [target]="getTarget(data)"
    [attr.buttonType]="data.buttonType"
    [attr.alignment]="data.alignment"
  >
    <span class="eb-cms-button__button-text">{{ data.text }}</span>
    <em *ngIf="data.icon" class="fas fa-{{ data.icon }}"></em
  ></cx-generic-link>
</ng-container>
